import React, { useCallback, useState } from 'react';
import I18N from '@leverege/i18n';
import { Button, CompositeTextInput } from '@leverege/ui-elements';
import S from './DeviceInput.css';
import { ignoreNonVINCharacterEvent } from '../../util/VIN';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.pairKeys.DeviceInput');
export default function DeviceInput(props) {
  const {
    hint,
    eventData,
    index,
    value,
    onChange,
    onFocus: pOnFocus,
    onClick,
    'data-test-postfix': testId,
    error
  } = props;
  const [val, setVal] = useState(value);
  const isParent = eventData === 'vin';

  // changes screen to search when user clicks input field
  const onFocus = useCallback(() => {
    pOnFocus({
      data: {
        screen: 'search',
        field: eventData,
        index
      }
    });
  }, [eventData, pOnFocus]);
  const onClear = useCallback(() => {
    setVal(null);
    // changes the keyId and imagine values to null for the selected component
    onChange({
      data: {
        field: eventData,
        index,
        keyId: null
      },
      value: null
    });
  });
  const onKeyDown = evt => isParent && ignoreNonVINCharacterEvent(evt);
  return /*#__PURE__*/_jsx("div", {
    className: S.inputContainer,
    children: /*#__PURE__*/_jsx(CompositeTextInput, {
      "data-test-id": `input.pairing.search${testId}`,
      variant: "scan",
      icon: value ? error ? tIcon('errorIcon') : tIcon('successIcon') : tIcon('searchIcon'),
      post: isParent ? /*#__PURE__*/_jsx(Button, {
        "data-test-id": `button.pairing.scan${testId}`,
        icon: t('cameraIcon'),
        onClick: onClick,
        eventData: {
          screen: 'scan',
          field: eventData
        },
        variant: "pairCamera|tertiarySmallIconic"
      }) : !val ? null : /*#__PURE__*/_jsx(Button, {
        variant: "pairClose",
        onClick: onClear
      }),
      hint: hint,
      value: val,
      eventData: {
        screen: 'search',
        field: eventData
      },
      onKeyDown: onKeyDown,
      onFocus: onFocus
    })
  });
}